import { BehavioralVerb } from 'apps/web/types/labelled-collection.type';
import { createOptions } from 'apps/web/types/option';

export const STANDARD_PERCEPTION_VERBS: BehavioralVerb[] = createOptions([
  'Activate',
  'Adjust',
  'Align',
  'Apply',
  'Arrange',
  'Assemble',
  'Balance',
  'Calibrate',
  'Choose',
  'Describe',
  'Detect',
  'Differentiate',
  'Distinguish',
  'Isolate',
  'Relate',
]);

export const STANDARD_SET_VERBS: BehavioralVerb[] = createOptions([
  'Begin',
  'Convert',
  'Correct',
  'Create',
  'Demonstrate',
  'Dismantle',
  'Drill',
  'Explain',
  'Fasten',
  'Fix',
  'Follow',
  'Grind',
  'Move',
  'Proceed',
  'React',
  'Show',
  'State',
  'Volunteer',
]);

export const STANDARD_GUIDED_RESPONSE_VERBS: BehavioralVerb[] = createOptions([
  'Follow',
  'Loosen',
  'Make',
  'Manipulate',
  'Mend',
  'Mix',
  'Nail',
  'Operate',
  'Press',
  'Produce',
  'React',
  'Reproduce',
  'Respond',
  'Trace',
]);

export const STANDARD_MECHANISM_VERBS: BehavioralVerb[] = createOptions([
  'Assemble',
  'Calibrate',
  'Construct',
  'Dismantle',
  'Fasten',
  'Fix',
  'Grind',
  'Heat',
  'Manipulate',
  'Measure',
  'Mend',
  'Mix',
  'Organize',
  'Saw',
  'Set',
  'Sharpen',
  'Transfer',
  'Troubleshoot',
  'Tune',
  'Turn on/off',
  'Type',
]);

export const STANDARD_COMPLEX_OVERT_RESPONSE_VERBS: BehavioralVerb[] =
  createOptions([
    'Accurately measure',
    'Adeptly manipulate',
    'Assemble',
    'Calibrate',
    'Carefully mend',
    'Clearly sketch',
    'Construct',
    'Dismantle',
    'Efficiently construct',
    'Fasten',
    'Fix',
    'Grind',
    'Heat',
    'Logically organize',
    'Manipulate',
    'Measure',
    'Mend',
    'Mix',
    'Neatly display',
    'Organize',
    'Precisely dismantle',
    'Reliably fix',
    'Safely heat',
    'Securely fasten',
    'Sketch',
    'Skillfully assemble',
    'Thoroughly mix',
  ]);

export const STANDARD_ADAPTATION_VERBS: BehavioralVerb[] = createOptions([
  'Alter',
  'Change',
  'Modify',
  'Rearrange',
  'Reorganize',
  'Revise',
  'Vary',
]);

export const STANDARD_ORIGINATION_VERBS: BehavioralVerb[] = createOptions([
  'Arrange',
  'Combine',
  'Construct',
  'Initiate',
  'Make',
  'Originate',
]);
